// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"98":"6e171253","464":"5b4df026","729":"f8ea2b3d","787":"5c65c091","812":"de538a55","921":"130577de"}[chunkId] + ".chunk.js";
};